import Vue from "vue";
import VueRouter from "vue-router";
import { userService } from "../api/user-auth";
import About from "../views/About.vue";
import Login from "../views/Login.vue";
import Jobs from "../views/Jobs.vue";
import Reports from "../views/Reports.vue";
import Customers from "../views/admin/Customers.vue";
import Personnels from "../views/admin/Personnels.vue";
import Users from "../views/admin/Users.vue";
import Vehicles from "../views/admin/Vehicles.vue";
import Inventory from "../views/admin/Inventory.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Jobs,
  },
  {
    path: "/about",
    name: "About",
    component: About,
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/jobs",
    name: "Jobs",
    component: Jobs,
  },
  {
    path: "/reports",
    name: "Reports",
    component: Reports,
  },
  {
    path: "/admin",
    name: "Admin",
    component: Customers,
  },
  {
    path: "/admin/customers",
    name: "Customers",
    component: Customers,
  },
  {
    path: "/admin/personnel",
    name: "Personnels",
    component: Personnels,
  },
  {
    path: "/admin/users",
    name: "Users",
    component: Users,
  },
  {
    path: "/admin/vehicles",
    name: "Vehicles",
    component: Vehicles,
  },
  {
    path: "/admin/inventory",
    name: "Inventory",
    component: Inventory,
  }
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
});

export default router;

router.beforeEach((to, from, next) => {
  // logout if requested
  if (to.path == "/logout") {
    userService.logout();
    return next("/login");
  } else {
    // redirect to login page if not logged in and trying to access a restricted page
    const publicPages = ["/login", "/register", "/config.json"];
    const authRequired = !publicPages.includes(to.path);
    const loggedIn = localStorage.getItem("user");

    if (authRequired && !loggedIn) {
      return next("/login");
    }

    next();
  }
});
